import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-phone-inprocess-conference.component.ajs.html';

const MODULE_NAME = 'agentBookingPhoneInprocessConference';

class AgentBookingPhoneInprocessConferenceCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  guestId: string;

  $onInit() {}
}

export class AgentBookingPhoneInprocessConference implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
    guestId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingPhoneInprocessConferenceCtrl];
}

export default MODULE_NAME;
